import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import {
  Actions,
  AppArea,
  MostFavouriteListFilterInput,
  MostFavouritesDocument,
  Subjects,
} from 'src/graphql/generated/graphql';
import { useTable } from 'src/hooks/use-table';
import { MostFavouriteTable } from './table';
import { Can } from 'src/utils/can';

const PAGINATION_LIMIT = 20;

type MostFavouriteListProps = {
  filter: MostFavouriteListFilterInput;
};

export const MostFavouriteList = ({ filter }: MostFavouriteListProps) => {
  const [totalCount, setTotalCount] = useState(0);

  const { page, setPage } = useTable();

  useEffect(() => {
    setPage(0);
  }, [setPage, filter]);

  const { loading, data } = useQuery(MostFavouritesDocument, {
    variables: {
      filter,
      pagination: {
        limit: PAGINATION_LIMIT,
        offset: page * PAGINATION_LIMIT,
      },
    },
    onCompleted: (data) =>
      setTotalCount(data?.mostFavourites?.pagination?.totalCount),
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-and-network',
  });

  const records = data?.mostFavourites?.records || [];

  return (
    <Can I={Actions.Read} a={Subjects.Favourites} appArea={AppArea.Most}>
      <MostFavouriteTable
        data={records}
        loading={loading}
        options={{
          page,
          count: totalCount,
          rowsPerPage: PAGINATION_LIMIT,
          onChangePage: setPage,
          enableNestedDataAccess: '.',
        }}
      />
    </Can>
  );
};
